import React, { FC, HTMLAttributes, memo } from 'react'

interface Props extends HTMLAttributes<HTMLSpanElement> {}

const TextButtonComponent: FC<Props> = ({ children, ...rest }) => {
  return (
    <span {...rest} className={'pointer ' + rest.className}>
      {children}
    </span>
  )
}

export const TextButton = memo(TextButtonComponent)
